import { render, staticRenderFns } from "./AgGridPagination.vue?vue&type=template&id=4f834acd&scoped=true&"
import script from "./AgGridPagination.vue?vue&type=script&lang=ts&"
export * from "./AgGridPagination.vue?vue&type=script&lang=ts&"
import style0 from "./AgGridPagination.vue?vue&type=style&index=0&id=4f834acd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f834acd",
  null
  
)

export default component.exports